(function () {
  function initMediaTabs() {
    const sourceSection = document.querySelector('[id^="product-tabs-"]');
    const wrapper = document.querySelector('.product-media__tabs-wrapper');
    if (!sourceSection || !wrapper) return;

    const sourceTitles   = [...sourceSection.querySelectorAll('.list-tabs .list-title')];
    const sourceContents = [...sourceSection.querySelectorAll('.product-tab-content')];
    if (sourceTitles.length === 0) return;

    // Re-use the <product-tabs> custom element so all tab + read-more logic
    // is handled automatically by product-tabs.js — no duplication needed.
    const tabsEl = document.createElement('product-tabs');
    tabsEl.className = 'product-tabs';

    // ── 1. Tab title list ─────────────────────────────────────────────────
    const listEl = document.createElement('ul');
    listEl.className = 'list-tabs';
    listEl.setAttribute('role', 'tablist');

    sourceTitles.forEach((title, i) => {
      const cloned = title.cloneNode(true);
      cloned.classList.toggle('is-active', i === 0);
      cloned.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      listEl.appendChild(cloned);
    });

    tabsEl.appendChild(listEl);

    // ── 2. Tab content panels ─────────────────────────────────────────────
    sourceContents.forEach((content, i) => {
      const cloned = content.cloneNode(true);

      // Remove original id to avoid duplicate IDs; matching is done via
      // data-tab-panel (already present from product-tabs.liquid)
      cloned.removeAttribute('id');
      cloned.classList.toggle('is-active', i === 0);

      // Fix any duplicate checkbox id / label[for] pairs (read-more widgets)
      cloned.querySelectorAll('input[type="checkbox"][id]').forEach(cb => {
        const oldId = cb.id;
        const newId = 'media-' + oldId;
        cb.id = newId;
        const label = cloned.querySelector(`label[for="${oldId}"]`);
        if (label) label.setAttribute('for', newId);
      });

      tabsEl.appendChild(cloned);
    });

    // Appending triggers connectedCallback on <product-tabs>,
    // which initialises all tab switching + read-more notifications.
    wrapper.appendChild(tabsEl);
    wrapper.style.display = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMediaTabs);
  } else {
    initMediaTabs();
  }
})();
